import { render, staticRenderFns } from "./bank-account-transaction.vue?vue&type=template&id=bb738c20"
import script from "./bank-account-transaction.vue?vue&type=script&lang=js"
export * from "./bank-account-transaction.vue?vue&type=script&lang=js"
import style0 from "./bank-account-transaction.vue?vue&type=style&index=0&id=bb738c20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports